import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import {
  PCTableInputModel,
  PCTableOutputModel,
  PCTableRowButtonModel,
} from '../../models/pc-table-input-model';
import {
  CdkDragDrop,
  CdkDropList,
  CdkDrag,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { CookieService } from 'ngx-cookie-service';
import { NumericService } from 'src/app/services/numeric.service';
import { Field } from '../../models/entity-defin';
import { LoggerService } from 'src/app/services/logger.service';
import * as _ from 'lodash-es';
import { ReturnModalComponent } from '../return-modal/return-modal.component';

@Component({
  selector: 'app-pctable',
  templateUrl: './pctable.component.html',
  styleUrls: ['./pctable.component.css'],
})
export class PCTableComponent implements OnChanges {
  constructor(
    private renderer: Renderer2,
    private logger: LoggerService,
    private cookieService: CookieService,
    public numericService: NumericService
  ) {
    this.renderer.listen('window', 'keyup', (e: any) => {
      if (e.key == 'ArrowUp' && this.focusRow > 0) {
        this.focusRow--;
      }

      if (e.key == 'ArrowDown' && this.data?.data.length > this.focusRow) {
        this.focusRow++;
      }

      if (
        e.key == 'Enter' &&
        this.focusRow > -1 &&
        this.focusRow < this.data?.data.length
      ) {
        this.callParent(this.data?.data[this.focusRow], 'SelectItem');
      }
    });
  }

  @Input() data?: PCTableInputModel;
  @Input() urlName?: string;
  @Input() tableResponsiveClass?: string;
  @Input() sort?: boolean;
  @Input() tdClassInput?: string;
  @Input() inlineEdit?: boolean;
  @Input() entityField?: Field[];
  @Input() loadInside?: boolean;
  @Output() parentAction = new EventEmitter<PCTableOutputModel>();

  public tableHeader!: Field[];
  public focusRow: number = -1;
  public tdClass: string = '';

  public resizingColumnIndex: number | null = null;
  public startX: number | null = null;
  public startWidth: number | null = null;

  public showPopup: boolean = false;
  public popupTop: number = 0;
  public popupLeft: number = 0;
  public rightClickItem: any | undefined;

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.loadInside == true) {
      if (
        changes['data'].currentValue != undefined &&
        changes['entityField'].currentValue != undefined
      ) {
        this.InitPage();
      }
    }
  }
  public InitPage() {
    try {
      if (this.entityField == null) {
        this.logger.addError('Column_Not_Load', false);
        return;
      }
      this.tdClass = this.tdClassInput ?? '';

      const storedColumns = this.getStoredColumns();
      const backendHeaderList = this.generateColumn();

      if (storedColumns == null || storedColumns.length == 0) {
        this.tableHeader = _.cloneDeep(backendHeaderList);
        this.setStoredColumns();
        this.testColumn();
        return;
      }

      for (let index = 0; index < storedColumns.length; index++) {
        const element = storedColumns[index];

        const foundedItem = backendHeaderList.find(
          (current) => current.camelCaseName == element.camelCaseName
        );

        if (foundedItem == null) {
          this.removeStoredColumns();
          this.tableHeader = _.cloneDeep(backendHeaderList);
          this.setStoredColumns();
          this.testColumn();
          return;
        }
      }

      this.tableHeader = _.cloneDeep(storedColumns);
      this.testColumn();
    } catch (error) {
      this.logger.addError('Exception_Js', false);
    }
  }

  private testColumn() {
    try {
      const item = this.data?.data[0];
      if (item == null) {
        return;
      }
      for (let index = 0; index < this.tableHeader.length; index++) {
        const element = this.tableHeader[index];

        if (!(element.camelCaseName! in item)) {
          this.logger.addError(
            'Problem On Load' + element.camelCaseName,
            false
          );
          return;
        }
      }
    } catch (error) {
      this.logger.addError('Exception_Js', false);
    }
  }

  private generateColumn(): Field[] {
    try {
      let backendHeaderList: string[] = [];
      return this.entityField!.filter(
        (current) => current.isVisibleInTable
      ).sort((current) => current.order);
    } catch (error) {
      this.logger.addError('Exception_Js', false);
      return [];
    }
  }

  public callParent(element: any, action: string) {
    try {
      if (this.inlineEdit == true && action == 'Edit') {
        element['inlineEditState'] = true;
      } else if (this.inlineEdit == true && action == 'Save') {
        element['inlineEditState'] = false;
      }
      this.parentAction.next(new PCTableOutputModel(action, element));
    } catch (error) {
      this.logger.addError('Exception_Js', false);
    }
  }

  public drop(event) {
    try {
      moveItemInArray(
        this.tableHeader,
        event.previousIndex,
        event.currentIndex
      );
      this.setStoredColumns();
    } catch (error) {
      this.logger.addError('Exception_Js', false);
    }
  }

  private getStoredColumns(): Field[] | null {
    try {
      const key = this.getStorageKey();
      const storedColumns = localStorage.getItem(key);
      if (storedColumns == 'undefined') {
        return null;
      }
      return storedColumns ? JSON.parse(storedColumns) : null;
    } catch (error) {
      this.logger.addError('Exception_Js', false);
      return null;
    }
  }

  private removeStoredColumns() {
    try {
      const key = this.getStorageKey();
      localStorage.removeItem(key);
    } catch (error) {
      this.logger.addError('Exception_Js', false);
    }
  }

  private setStoredColumns() {
    try {
      const key = this.getStorageKey();
      localStorage.setItem(key, JSON.stringify(this.tableHeader));
    } catch (error) {
      this.logger.addError('Exception_Js', false);
    }
  }

  private getStorageKey(): string {
    try {
      if (this.urlName) {
        return this.urlName;
      }
      return `columnsArray_${window.location.pathname}`;
    } catch (error) {
      this.logger.addError('Exception_Js', false);
      return '';
    }
  }

  public getInputType(value: any): string {
    return typeof value === 'number' ? 'number' : 'text';
  }

  public checkNumber(rowIndex: number, cell: string) {
    try {
      if (this.data?.data == null) {
        return;
      }

      let row = this.data.data[rowIndex];

      if (row == null) {
        return;
      }

      let item = row[cell];

      if (item == null) {
        return;
      }

      this.data.data[rowIndex][cell] = this.numericService.checkNumber(item);
    } catch (error) {
      this.logger.addError('Exception_Js', false);
    }
  }

  public onMouseDown(event: MouseEvent, index: number) {
    this.resizingColumnIndex = index;
    this.startX = event.pageX;
    const th = event.target as HTMLElement;
    this.startWidth = th.parentElement?.offsetWidth || 0;
    event.preventDefault();
  }

  @HostListener('document:mousemove', ['$event'])
  public onMouseMove(event: MouseEvent): void {
    if (
      this.resizingColumnIndex !== null &&
      this.startX !== null &&
      this.startWidth !== null
    ) {
      const th = document.querySelectorAll('th')[
        this.resizingColumnIndex
      ] as HTMLElement;
      const table = th.closest('table') as HTMLElement;
      const scrollLeft = table.parentElement?.scrollLeft || 0;
      const minWidth = 50; // حداقل عرض ستون به پیکسل
      const newWidth = Math.max(
        minWidth,
        this.startWidth - (event.clientX - this.startX - scrollLeft)
      ); // تنظیم عرض جدید با حداقل عرض
      th.style.width = `${newWidth}px`;
    }
  }

  @HostListener('document:mouseup', ['$event'])
  public onMouseUp(event: MouseEvent): void {
    this.resizingColumnIndex = null;
    this.startX = null;
    this.startWidth = null;
  }

  public RebuildColumn() {
    this.removeStoredColumns();
    this.InitPage();
  }

  openNote(event: MouseEvent, item: any) {
    event.preventDefault();

    this.rightClickItem = item;
    const offsetY = event.offsetY;
    const offsetX = event.offsetX;

    const customEvent = event as any;
    this.popupTop =
      customEvent.layerY == undefined ? offsetY : customEvent.layerY;
    this.popupLeft =
      customEvent.layerX == undefined ? offsetX : customEvent.layerX;

    this.showPopup = true;
  }

  @HostListener('document:click')
  closePopup() {
    this.showPopup = false;
  }

  public checkConditionButton(row: any, item: PCTableRowButtonModel): boolean {
    if (item.condition == null) {
      return true;
    }

    let condition = item.condition;
    const index = item.condition.indexOf('!');
    if (index >= 0) {
      condition = item.condition.replace('!', '');
    }

    if (row[condition] == null) {
      return true;
    }

    if (row[condition] == false && index < 0) {
      return false;
    }

    if (row[condition] == true && index >= 0) {
      return false;
    }

    if (item.secondCondition == null) {
      return true;
    }

    let secondCondition = item.secondCondition;
    const secondIndex = item.secondCondition.indexOf('!');
    if (secondIndex >= 0) {
      secondCondition = item.secondCondition.replace('!', '');
    }

    if (row[secondCondition] == null) {
      return true;
    }

    if (row[secondCondition] == false && secondIndex < 0) {
      return false;
    }

    if (row[secondCondition] == true && secondIndex >= 0) {
      return false;
    }

    return true;
  }
}
